"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as s } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: t, size: c = 24 } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = n(), e = t !== null && t !== void 0 ? t : i ? o.colors.inverse : o.colors.neutralHigh, { skinName: r } = s();
    return r.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M20.383 6.342a1.623 1.623 0 0 0-1.451 2.328l-4.782 4.832-1.388-1.402 6.934-7.008c.211.102.445.162.692.162.888 0 1.612-.731 1.612-1.63a1.62 1.62 0 0 0-1.617-1.62 1.623 1.623 0 0 0-1.451 2.329l-6.93 7.003-1.387-1.403L15.4 5.097c.211.101.445.161.692.161.889 0 1.612-.73 1.612-1.629 0-.898-.724-1.629-1.612-1.629a1.623 1.623 0 0 0-1.452 2.328L9.854 9.165l-.146-.148a1.365 1.365 0 0 0-1.946 0L2 14.863 9.685 22l5.358-5.628a1.405 1.405 0 0 0 0-1.967l-.132-.135 4.785-4.837c.211.102.445.162.692.162.888 0 1.612-.73 1.612-1.629 0-.898-.728-1.624-1.617-1.624m0-3.254a.54.54 0 0 1 .536.541.54.54 0 0 1-.536.542.542.542 0 0 1 0-1.083m-3.755.541a.54.54 0 0 1-.536.542.54.54 0 0 1-.536-.542.54.54 0 0 1 .536-.541.54.54 0 0 1 .536.541M9.62 19.977l-5.556-5.16 4.672-4.74 5.253 5.313zM19.848 7.971c0-.296.242-.542.535-.542a.542.542 0 0 1 0 1.083.54.54 0 0 1-.535-.541"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M20.383 6.342a1.623 1.623 0 0 0-1.451 2.328l-4.782 4.832-1.388-1.402 6.934-7.008c.211.102.445.162.692.162.888 0 1.612-.731 1.612-1.63a1.62 1.62 0 0 0-1.617-1.62 1.623 1.623 0 0 0-1.451 2.329l-6.93 7.003-1.387-1.403L15.4 5.097c.211.101.445.161.692.161.889 0 1.612-.73 1.612-1.629 0-.898-.724-1.629-1.612-1.629a1.623 1.623 0 0 0-1.452 2.328L9.854 9.165l-.146-.148a1.365 1.365 0 0 0-1.946 0L2 14.863 9.685 22l5.358-5.628a1.405 1.405 0 0 0 0-1.967l-.132-.135 4.785-4.837c.211.102.445.162.692.162.888 0 1.612-.73 1.612-1.629 0-.898-.728-1.624-1.617-1.624m0-3.254a.54.54 0 0 1 .536.541.54.54 0 0 1-.536.542.542.542 0 0 1 0-1.083m-3.755.541a.54.54 0 0 1-.536.542.54.54 0 0 1-.536-.542.54.54 0 0 1 .536-.541.54.54 0 0 1 .536.541M9.62 19.977l-5.556-5.16 4.672-4.74 5.253 5.313zM19.848 7.971c0-.296.242-.542.535-.542a.542.542 0 0 1 0 1.083.54.54 0 0 1-.535-.541"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M5.609 20.114a7.4 7.4 0 0 1-.838-.696c-1.736-1.675-2.616-4.17-2.616-7.417s.88-5.742 2.616-7.417c1.673-1.611 4.107-2.429 7.23-2.429s5.557.818 7.23 2.429c1.736 1.672 2.616 4.168 2.616 7.417 0 3.25-.88 5.742-2.616 7.417-1.673 1.61-4.107 2.429-7.23 2.429-2.47 0-4.509-.512-6.08-1.522a.56.56 0 0 1-.312-.211m.418-1.087 2.683-2.648-.603-.61-.605-.611-2.668 2.63a6.3 6.3 0 0 0 1.193 1.239m.962.627c1.326.712 3.004 1.072 5.012 1.072 2.824 0 4.994-.711 6.45-2.114 1.51-1.454 2.275-3.678 2.275-6.611s-.764-5.154-2.274-6.61C16.995 3.986 14.824 3.274 12 3.274c-2.824 0-4.994.712-6.451 2.115C4.04 6.844 3.275 9.068 3.275 12c0 1.906.323 3.51.963 4.8l2.875-2.836a.56.56 0 0 1 .793.006l.193.196c.675-1.341 1.375-3.322 1.566-5.952a1.35 1.35 0 0 1-.457-.317Q8.8 7.471 8.8 6.788q.001-.68.41-1.11a1.45 1.45 0 0 1 1.066-.436c.423 0 .793.151 1.068.437q.41.43.409 1.11c0 .45-.138.823-.41 1.108a1.36 1.36 0 0 1-.56.356c-.15 2.129-.616 3.868-1.15 5.216l4.86-4.801a1.36 1.36 0 0 1-.116-.594q.017-.589.505-1.07.487-.48 1.075-.493c.398-.011.768.14 1.067.437.3.297.457.666.446 1.064q-.018.589-.505 1.07-.487.478-1.075.493a1.4 1.4 0 0 1-.605-.117l-4.768 4.705c1.33-.51 3.023-.952 5.079-1.098a1.4 1.4 0 0 1 .355-.56c.283-.272.656-.409 1.11-.409q.683.002 1.109.412c.283.272.437.644.437 1.067s-.151.793-.437 1.07-.655.41-1.11.41c-.453 0-.823-.14-1.109-.41a1.4 1.4 0 0 1-.316-.456c-2.639.19-4.622.896-5.966 1.574l.224.227a.56.56 0 0 1-.006.792zm9.656-6.062c.003.143.048.204.093.246.025.026.103.099.333.099s.308-.073.333-.098c.045-.045.093-.11.093-.261s-.048-.216-.093-.26c-.025-.026-.103-.099-.333-.099s-.308.073-.333.099c-.045.044-.093.109-.093.257v.011q-.005.005 0 .006m-.781-5.132c.036 0 .148-.002.316-.17.16-.161.168-.26.17-.298l.001-.005c.003-.059-.011-.135-.112-.235-.1-.101-.185-.118-.25-.115-.036 0-.148.003-.316.17-.16.161-.168.26-.17.298v.005c-.004.056.008.132.109.233.109.106.187.12.252.117M10.28 7.214c.149 0 .213-.048.258-.093.025-.025.098-.1.098-.333 0-.232-.073-.308-.098-.333-.045-.045-.11-.093-.26-.093-.152 0-.216.048-.261.093-.025.025-.098.1-.098.333s.073.308.098.333c.042.045.103.09.246.093z"
        })
    }));
}, d = m;
export { d as default };
